export async function fetchWebsiteData() {
  try {
    const response = await fetch("https://nervmonk.github.io/website-data/website_data.json?ts=" + Date.now()); // always calls different url to invalidate browser cache
    if (!response.ok) throw new Error("Network error");
    return await response.json();
  } catch (error) {
    console.error("Error fetching website data:", error);
    // dummy fallback just in case github down
    return {
      tkbData: {
        tkb0: "N/A",
        tkb30: "N/A",
        tkb60: "N/A"
      },
      businessData: {
        borrowerSinceFirst: {
          value: "N/A"
        },
        borrowerSinceYear: {
          value: "N/A"
        },
        borrowerEndPosition: {
          value: "N/A"
        },
        lenderSinceFirst: {
          value: "5 Entitas"
        },
        lenderInYear: {
          value: "5 Entitas"
        },
        lenderEndPosition: {
          value: "5 Entitas"
        },
        disburseSinceFirst: {
          value: "N/A"
        },
        disburseInYear: {
          value: "N/A"
        },
        disburseEndPosition: {
          value: "N/A"
        },
        unpaidAmount: {
          value: "N/A"
        }
      }
    };
  }
}


// mba maud izin tanya dong, aku sama yan xu mau nge outsource data dinamis di website biar bisa kita gonta-ganti tanpa harus minta tolong dia redeploy terus2an
// just in case, and this is super rare case, kalau server data dinamisnya ada downtime, is it better kalau di website kita taruh fallback data random atau tulisan N/A?

// skenario semuanya berjalan normal dan ini data real

// skenario saat server data dinamis downtime dan ini angka yang kita karang (not too obvious, obviously)
// ini kalau pake N/A

